import { createAction, props, union } from '@ngrx/store';
import { LogMessage } from '@app/core/models/log-message';

export const LoggerLog = createAction('[Logger] Log', props<{ logMessage: LogMessage }>());
export const Log = createAction('[Logger] Log2', props<{ level: number; source: string; message: string; object?: any }>());
export const LoggerLogDebug = createAction('[Logger] Log Debug', props<{ message: string; object?: any }>());
export const LoggerLogInfo = createAction('[Logger] Log Info', props<{ message: string; object?: any }>());
export const LoggerLogWarn = createAction('[Logger] Log Warn', props<{ message: string; object?: any }>());
export const LoggerLogError = createAction('[Logger] Log Error', props<{ message: string; object?: any }>());
export const LoggerClearLog = createAction('[Logger] Clear Log');
export const SetLogLevel = createAction('[Logger] Set Log Level', props<{ level: number }>());

export const LoggerActions = union({
  LoggerLog
 , Log
 , LoggerLogDebug
 , LoggerLogInfo
 , LoggerLogWarn
 , LoggerLogError
 , LoggerClearLog
 , SetLogLevel
});

/*
export class Log implements Action {
  readonly type = LoggerActionTypes.Log;

  constructor(public payload: ) {
    console.log('Log.payload', payload.object);
    if (payload.object) {
      console.log('typeof payload.object', typeof payload.object);

      if (typeof payload.object === 'object') {
        console.log('payload.object.constructor.name', payload.object.constructor.name);

        if (payload.object.constructor.name === 'HttpErrorResponse') {
          const error: HttpErrorResponse = payload.object;

          if (error.status === 401) {
            payload.level = 5;
            payload.message = 'Login session invalid or expired';
          }
        }
      }
    }
  }
}
*/
